<div
  class="cash-preset-button"
  [class.cash-preset-button--selected]="isSelected"
>
  <span
    *ngIf="showChip"
    class="cash-preset-button__chip"
    aria-hidden="true"
  >{{ safeCount }}</span>

  <button
    *ngIf="isSelected"
    type="button"
    class="cash-preset-button__step cash-preset-button__step--minus"
    (click)="onDecrement($event)"
    [attr.aria-label]="'Decrease by ' + displayLabel"
  >
    <span aria-hidden="true">−</span>
  </button>

  <button
    *ngIf="!isSelected"
    type="button"
    class="cash-preset-button__label cash-preset-button__label--add"
    [attr.aria-label]="'Add ' + displayLabel"
    (click)="onAdd()"
  >
    {{ displayLabel }}
  </button>

  <span
    *ngIf="isSelected"
    class="cash-preset-button__label"
    aria-hidden="true"
  >{{ displayLabel }}</span>

  <button
    *ngIf="isSelected"
    type="button"
    class="cash-preset-button__step cash-preset-button__step--plus"
    (click)="onIncrement($event)"
    [attr.aria-label]="'Increase by ' + displayLabel"
  >
    <span aria-hidden="true">+</span>
  </button>
</div>
